import { Injectable } from '@angular/core';
import { SecurityService } from '../../../services/security.service';
import { TimezoneService } from '../../../services/date/timezone.service';
import { DateService } from '../../../services/date/date.service';
import { MoneyTalk } from './money-talk.domain';

@Injectable()
export class MoneyTalkService {

  constructor(private securityService: SecurityService,
              private timezoneService: TimezoneService) {
  }

  isMoneyTalkLiveNow(moneyTalk: MoneyTalk): boolean {
    const today = new Date();
    const serverTime = this.timezoneService.adjustToServerTimezone(today);
    return moneyTalk?.showLiveNow && !DateService.isWeekend(today) ?
      serverTime.getHours() === 12 && serverTime.getMinutes() <= 45 : false;
  }

  showMoneyTalk(): boolean {
    return this.securityService.hasPermission('DIRECT_INVESTING');
  }
}

